import * as React from "react";
import { TimelineMax } from "gsap";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";
import { WithContext as ReactTags } from "react-tag-input";
import { Drawer } from "@material-ui/core";
import Picker from "emoji-picker-react";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import * as action from "../../../redux/actions/actions";
import "./styles.css";
import { ReactComponent as UserIcon } from "../../../images/usr_icn.svg";
import { ReactComponent as GroupLogo } from "../../../images/grp_icon.svg";
import * as commonMethod from "../../../commonMethods";
import { store } from "../../../../index";
import { ReactComponent as CrossIcon } from "../../../images/cross.svg";
import { ReactComponent as GlobeIcon } from "../../../images/globe.svg";
import { ReactComponent as PicIcon } from "../../../images/pic.svg";
import { ReactComponent as EmojiIcon } from "../../../images/emoji.svg";
import { ReactComponent as SendIcon } from "../../../images/send.svg";
import { ReactComponent as BackIcon } from "../../../images/left_arrow.svg";
import { ReactComponent as PlusIcon } from "../../../images/plus.svg";
import _ from "lodash";
import { Guid } from "guid-typescript";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
// This only needs to be imported once in your app 
import { parsePhoneNumber } from "libphonenumber-js";
const KeyCodes = { comma: 188, enter: 13 };
const delimiters = [KeyCodes.comma, KeyCodes.enter];
class NewMessage extends React.Component<any, any> {
  public checkValidMessage: any;
  state = {
    showinfo: false,
    displayEmojiPicker: false,
    inputText: "",
    sharedinboxname: "",
    sharedinboxuniquenumber: "",
    sharedemail: "",
    SharedInbox: _.cloneDeep(this.props.sharedInboxData) || null,
    checkPhone: false,
    file: [],
    fileBlob: "",
    fileName: '',
    progressBar: 0,
    disableSendMessage: false,
    isOpen: false,
    isContainWords: false,
    numlengthError: false,
    isNumberCode: false,
    index:-1
  };
  reactTags: any;
  constructor(props: any, state: any) {
    super(props);
    this.reactTags = React.createRef();
  }
  componentWillMount() {
    this.props.setSelectedContacts([]);
  }
  setShareInbox(event: any) {
    this.state.SharedInbox.other = this.state.SharedInbox.other.filter((x: any) => x.name !== event.name);
    this.state.SharedInbox.other.push({
      UniqueNumber: this.state.sharedinboxuniquenumber !== "" ? this.state.sharedinboxuniquenumber : this.state.SharedInbox ? this.state.SharedInbox.currentSelected.UniqueNumber : "",
      email: this.state.sharedemail !== "" ? this.state.sharedemail : this.state.SharedInbox && this.state.sharedinboxname !== store.getState().reduxReducer.loggedInUser.UserName ? this.state.SharedInbox.currentSelected.email : "",
      name: this.state.sharedinboxname !== "" ? this.state.sharedinboxname : this.state.SharedInbox ? this.state.SharedInbox.currentSelected.name : "",
    });
    if (this.state.sharedinboxname !== event.name) {
      this.setState({ sharedinboxname: event.name, sharedinboxuniquenumber: event.UniqueNumber, sharedemail: event.email, });
    }
    this.props.setCurrentSelectedSharedEmail(event);
  }

  Showinfo(event: any) {
    var tl = new TimelineMax();
    if (this.state.showinfo === false) {
      tl.from(".info_sec", 1, {
        margin: "0 0 0 0",
        left: "0",
      });
      tl.reversed(false);
      tl.reversed(!tl.reversed());
      this.setState({ showinfo: true });
    } else {
      this.setState({ showinfo: false });
      tl.from(".info_sec", 1, {
        marginRight: "-500",
      });
      tl.reversed(true);
      tl.reversed(tl.reversed());
    }
  }
  handleDelete = (i: number) => {
    debugger;
    const newSelectedContacts = this.props.selectedContactsNewMessage.filter((c: any, j: number) => j !== i);
    this.props.setSelectedContacts(newSelectedContacts);
    this.props.messageSelectedContactsCount(newSelectedContacts?.length);

  };
 
  
  checkValidPhoneNumber = (phoneNumber: any) => {
    let isnum = /^[-+]?[0-9]+$/.test(phoneNumber);
    
    if (phoneNumber?.replace(/\D/g,'')?.length > 15) {
      return phoneNumber;
    }
    if (isnum !== true) {
      return phoneNumber;
    } else {
      const JSONMappingData = '{"93":"AF","358":"AX","355":"AL","213":"DZ","1684":"AS","376":"AD","244":"AO","1264":"AI","1268":"AG","54":"AR","374":"AM","297":"AW","61":"AU","43":"AT","994":"AZ","1242":"BS","973":"BH","880":"BD","1246":"BB","375":"BY","32":"BE","501":"BZ","229":"BJ","1441":"BM","975":"BT","591":"BO","5997":"BQ","387":"BA","267":"BW","55":"BR","246":"IO","1284":"VG","673":"BN","359":"BG","226":"BF","257":"BI","855":"KH","237":"CM","1":"CA","238":"CV","1345":"KY","236":"CF","235":"TD","56":"CL","86":"CN","61":"CX","61":"CC","57":"CO","269":"KM","242":"CG","243":"CD","682":"CK","506":"CR","385":"HR","53":"CU","599":"CW","357":"CY","420":"CZ","45":"DK","253":"DJ","1767":"DM","1809":"DO","593":"EC","20":"EG","503":"SV","240":"GQ","291":"ER","372":"EE","251":"ET","500":"FK","298":"FO","679":"FJ","358":"FI","33":"FR","594":"GF","689":"PF","241":"GA","220":"GM","995":"GE","49":"DE","233":"GH","350":"GI","30":"GR","299":"GL","1473":"GD","590":"GP","1671":"GU","502":"GT","44":"GG","224":"GN","245":"GW","592":"GY","509":"HT","379":"VA","504":"HN","852":"HK","36":"HU","354":"IS","91":"IN","62":"ID","225":"CI","98":"IR","964":"IQ","353":"IE","44":"IM","972":"IL","39":"IT","1876":"JM","81":"JP","44":"JE","962":"JO","76":"KZ","254":"KE","686":"KI","965":"KW","996":"KG","856":"LA","371":"LV","961":"LB","266":"LS","231":"LR","218":"LY","423":"LI","370":"LT","352":"LU","853":"MO","389":"MK","261":"MG","265":"MW","60":"MY","960":"MV","223":"ML","356":"MT","692":"MH","596":"MQ","222":"MR","230":"MU","262":"YT","52":"MX","691":"FM","373":"MD","377":"MC","976":"MN","382":"ME","1664":"MS","212":"MA","258":"MZ","95":"MM","264":"NA","674":"NR","977":"NP","31":"NL","687":"NC","64":"NZ","505":"NI","227":"NE","234":"NG","683":"NU","672":"NF","850":"KP","1670":"MP","47":"NO","968":"OM","92":"PK","680":"PW","970":"PS","507":"PA","675":"PG","595":"PY","51":"PE","63":"PH","64":"PN","48":"PL","351":"PT","1787":"PR","974":"QA","383":"XK","262":"RE","40":"RO","7":"RU","250":"RW","590":"BL","290":"SH","1869":"KN","1758":"LC","590":"MF","508":"PM","1784":"VC","685":"WS","378":"SM","239":"ST","966":"SA","221":"SN","381":"RS","248":"SC","232":"SL","65":"SG","1721":"SX","421":"SK","386":"SI","677":"SB","252":"SO","27":"ZA","500":"GS","82":"KR","211":"SS","34":"ES","94":"LK","249":"SD","597":"SR","4779":"SJ","268":"SZ","46":"SE","41":"CH","963":"SY","886":"TW","992":"TJ","255":"TZ","66":"TH","670":"TL","228":"TG","690":"TK","676":"TO","1868":"TT","216":"TN","90":"TR","993":"TM","1649":"TC","688":"TV","256":"UG","380":"UA","971":"AE","44":"GB","1":"US","598":"UY","998":"UZ","678":"VU","58":"VE","84":"VN","681":"WF","212":"EH","967":"YE","260":"ZM","263":"ZW"}';
      const mappingData = JSON.parse(JSONMappingData);
      const countryCode = mappingData[this.props.loggedInUserDefaultCountryCode];
      const phoneNumber1 = parsePhoneNumber(phoneNumber, countryCode);
      if (phoneNumber1) {
        if (phoneNumber1.isValid() === true) {
          return phoneNumber1.format("E.164");
        } else {
          return phoneNumber;

        }
        return phoneNumber;

      }
    }
  };
  sendMessage = (e: any) => {
    
    if(this.props.selectedContactsNewMessage.length !== 0){
    if (e.key === "Enter") {
      if (e.shiftKey) {
        this.setState({ inputText: e.target.value + "\n" });
        e.preventDefault();
        return
      }
      else if (e.preventDefault) e.preventDefault();
      var email = this.props.sharedInboxData.currentSelected.email;
      if (this.props.selectedContactsNewMessage !== undefined) {
        this.setState({ disableSendMessage: true })
        var SharedInboxemail = this.props.sharedInboxData.currentSelected.email;
        if (this.props.sharedInboxData !== undefined && this.props.sharedInboxData?.other?.length > 0) {
          var Getselectedinbox = this.props.sharedInboxData?.other?.filter((x: any) => x?.email === email);
          if (Getselectedinbox?.length > 0 && Getselectedinbox[0]?.email !== store.getState().reduxReducer.loggedInUser?.Email) {
            this.props.sendMessageProp(this.props.selectedContactsNewMessage, this.state.inputText, Getselectedinbox[0]?.email, this.state.file);
            this.setState({ disableSendMessage: false })
          }
          else if (SharedInboxemail !== undefined && SharedInboxemail !== "" && SharedInboxemail !== null && SharedInboxemail !== store.getState().reduxReducer.loggedInUser.Email) {
            this.props.sendMessageProp(this.props.selectedContactsNewMessage, this.state.inputText, SharedInboxemail, this.state.file);
            this.setState({ disableSendMessage: false })
          } else {
            this.props.sendMessageProp(this.props.selectedContactsNewMessage, this.state.inputText, email, this.state.file);
            this.setState({ disableSendMessage: false })
          }
        }
      }
    }
  }else{
    this.props.setAlertData({ className: "danger", text: "At least one phone number or contact is required", });
    setTimeout(() => { this.props.setAlertData(null); }, 5000);
  }
  };
  handleChange = (event: any) => {
    let idCardBase64 = '';
    var imgaeName = Guid.create();
    var fileType = event.target.files[0]?.type.split('/');
    var imageSize = Math.round(event.target.files[0]?.size / Math.pow(1024, 1));
    var fileName = imgaeName + '.' + fileType[1];
    var allowedType = fileType[1]?.split(',').toString();
    if (allowedType !== "gif" && allowedType !== "jpg" && allowedType !== "jpeg" && allowedType !== "png" && allowedType !== "pjpeg" && allowedType !== "pjp" && allowedType !== "jfif") {
      this.props.setAlertData({ className: "danger", text: "Please Choose Valid File!", });
      setTimeout(() => { this.props.setAlertData(null); }, 2000);
    }
    else {
      if (imageSize < 5000) {
        this.setState({ progressBar: 40 })
        var ArrayFiles:any=this.state.file;
        var fileData:any = {};
        let ff=event.target.files[0];
        this.getBase64(event.target.files[0], (result: any) => {
          idCardBase64 = result;
          var blob = result.split(',');
          fileData={ url: URL.createObjectURL(ff),name: fileName , blob: blob[1] };
          ArrayFiles.push(fileData);
          this.setState({ file:ArrayFiles });
          this.setState({ fileBlob: blob[1] })
          setTimeout(() => {
            this.setState({
              progressBar: 100
            })
          }, 1000);
        });
      }
      else {
        this.props.setAlertData({ className: "danger", text: "Size must be less than 5mb", });
        setTimeout(() => { this.props.setAlertData(null); }, 2000);
      }
    }
  }
  getBase64(file: any, callback: any) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result);
    reader.onerror = error => { };
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.currentTheme !== prevState.currentTheme || nextProps.testData !== prevState.testName
      || nextProps.spinnerValue !== prevState.spinnerValueState ||
      nextProps.whiteLabelBrand !== prevState.whiteLabelBrand
    ) {
      return {
        spinnerValueState: nextProps.spinnerValue,
        whiteLabelBrand: nextProps.whiteLabelBrand
      }
    } else {
      return null
    }
  }
  render() {
    const setIndex=(FF:any,x:any)=>{
      debugger;
      const istheImage = (element: any) => element.name ==FF;
      let img=this.state.file.findIndex(istheImage);
this.setState({index:img});
    }
const currentImage:any =this.state.file[this.state.index];
  const nextIndex = (this.state.index + 1) % this.state.file.length;
  const nextImage:any = this.state.file[nextIndex] || currentImage;
  const prevIndex = (this.state.index + this.state.file.length - 1) % this.state.file.length;
  const prevImage:any = this.state.file[prevIndex] || currentImage;

  const handleClick = (index: number) => this.setState({index:index});
  const handleClose = () => this.setState({index:-1});
  const handleMovePrev = () => this.setState({index:prevIndex});
  const handleMoveNext = () =>this.setState({index:nextIndex});
    const alertValid = this.props.selectedContactsNewMessage.map((num: any, numKey: number) => {
      const mobileNum = num.mobilePhone;
      const YakChatNum = num.PhoneNumber;
      if (num.mobilePhone) {
        var newNumber = num.mobilePhone?.replace(/\D/g, '')
      } else {
        var newNumber = num.PhoneNumber?.replace(/\D/g, '')
      }
      if (newNumber?.length > 12) {
        this.checkValidMessage = true;
        this.props.setAlertData({ className: "danger", text: "Invalid number, please check the contact number and try again", });
        setTimeout(() => { this.props.setAlertData(null); }, 3000);

      } else {
        this.checkValidMessage = false;
      }
      if (mobileNum === null || YakChatNum === null || mobileNum === "") {
        this.checkValidMessage = true;
        this.props.setAlertData({ className: "danger", text: "Invalid number, please check the contact number and try again", });
        setTimeout(() => { this.props.setAlertData(null); }, 2000);
      } else {
        this.checkValidMessage = false;
      }
    });
    var valueArr =  this.props.selectedContactsNewMessage.map(function(item:any){ return item.mobilePhone!== undefined ?
       item.mobilePhone.startsWith("+1") ?  item.mobilePhone.substring(2) : item.mobilePhone.startsWith("1") ? item.mobilePhone.substring(1) :item.mobilePhone.replace(/\+/g,' ').trim() :  item.PhoneNumber.startsWith("+1") ?  item.PhoneNumber.substring(2) : item.PhoneNumber.startsWith("1") ? item.PhoneNumber.substring(1) :
       item.PhoneNumber.startsWith("+44") ?  item.PhoneNumber.substring(3) : item.PhoneNumber.replace(/\+/g,' ').trim(); });
    var isDuplicate = valueArr.some(function(item:any, idx:any){ 
        return valueArr.indexOf(item) != idx 
    });
    
    if(isDuplicate === true){
      this.props.selectedContactsNewMessage.pop();
    }   
    const tags = this.props.selectedContactsNewMessage.map((c: any, i: number) => {
      if (c.mobilePhone !== undefined) {
        c.mobilePhone = c.mobilePhone?.replace(/[^0-9+]+/g, "");
        let number = c.mobilePhone?.replace(/[^0-9+]+/g, "");
        var phonelength = number?.length
      } else if (c.PhoneNumber !== undefined) {
        var phoneLength = c.PhoneNumber?.Length
      }
      //  if(this.state.isContainWords === true){
      //  const v= (this.props.setAlertData({ className: "danger", text: "Please enter a " }),setTimeout(() => { this.props.setAlertData(null); }, 1500)) ;
      //  }
      const text = c.type?.startsWith("YakChat") ? (c.ForeName ? c.ForeName : "") + " " + (c.PhoneNumber ? c.SureName : "") : c.displayName ? c.displayName : c.type?.startsWith("New Contact") ? c.mobilePhone !== "↵" ? this.checkValidPhoneNumber(c.mobilePhone) : "" : "";
      const u = c.type?.startsWith("New Contact") ? text?.includes("+") ? "" : (this.props.setAlertData({ className: "danger", text: "Please enter a valid number" }), setTimeout(() => { this.props.setAlertData(null); }, 1500)) : "";
      return {
        id: JSON.stringify(i),
        text: text,
        className: [c.type?.startsWith("New Contact") ? text?.includes("+") ? "" : "redtag" : c.type?.startsWith("Outlook") || c.type?.startsWith("Share Point") || c.type?.startsWith("Users") ? c.mobilePhone ? "" : "redtag" : c.type?.startsWith("YakChat") ? c.PhoneNumber ? "" : "redtag" : "", phonelength > 15 ? "redtag" : ""],
      };

    });
    return (
      <div className="right_Sec" id="right_Sec_main">
        <div className="resize-right-sec">
          <div className="top_row resize-top-row mobile_topBar" style={{ display: "flex" }}>
            <div className="topBar_mobileDiv">
              <div className="topBar_mobile">
                <span className="message-span">To:</span>
                <span
                  className="resize-top-row"
                  style={{ width: "100%" }}
                  onClick={() => {
                    const elems = document.getElementsByClassName("ReactTags__tagInputField") as HTMLCollectionOf<HTMLElement>;
                    if (elems?.length > 0) {
                      elems[0]!.focus();
                    }
                  }}
                >
                  <ReactTags
                    inline={true}
                    ref={this.reactTags}
                    tags={tags}
                    handleDelete={this.handleDelete}
                    handleAddition={(tag) => {
                      tag.id = tag.id?.replace(/[\n\r]/g, " ");
                      if (tag.id !== "NOT_A_NUMBER" && tag.id !== " "  ) {
                        
                      const newSelectedContacts = [...this.props.selectedContactsNewMessage, { type: "New Contact", mobilePhone: tag.text },];
                      var valueArr = newSelectedContacts.map(function(item){ return item.mobilePhone!== undefined ?  item.mobilePhone.startsWith("+1") ?  item.mobilePhone.substring(2) : item.mobilePhone.startsWith("1") ? item.mobilePhone.substring(1) :
                      item.mobilePhone.startsWith("+44") ? item.mobilePhone.substring(3) :  item.mobilePhone.startsWith("+61") ? item.mobilePhone.substring(3) :
                      item.mobilePhone.replace(/\+/g,' ').trim() :  item.PhoneNumber.startsWith("+1") ?  item.PhoneNumber.substring(2) : item.PhoneNumber.substring("1") ? item.PhoneNumber.substring(1) : 
                      item.PhoneNumber.startsWith("+44") ?  item.PhoneNumber.substring(3) : item.PhoneNumber.startsWith("+61") ?  item.PhoneNumber.substring(3) :
                       item.PhoneNumber.replace(/\+/g,' ').trim(); });
                      var isDuplicate = valueArr.some(function(item, idx){ 
                          return valueArr.indexOf(item) != idx 
                      });
                      
                      if(isDuplicate !== true){
                        this.props.setSelectedContacts(newSelectedContacts);
                      }else{
                        newSelectedContacts.pop(); }
                      }
                    }}
                    handleInputBlur={(value: any) => {
                      var isNumber = /^[-+]?[0-9]+$/.test(value); 
                      if (value !== "" &&  isNumber) {   
                        var number = this.checkValidPhoneNumber(value);
                        
                        const newSelectedContacts = [...this.props.selectedContactsNewMessage, { type: "New Contact", mobilePhone: number }];
                        var valueArr = newSelectedContacts.map(function(item){ return item.mobilePhone!== undefined ?  item.mobilePhone.startsWith("+1") ?  item.mobilePhone.substring(2) : item.mobilePhone.startsWith("1") ? item.mobilePhone.substring(1) :
                        item.mobilePhone.startsWith("+44") ? item.mobilePhone.substring(3) :  item.mobilePhone.startsWith("+61") ? item.mobilePhone.substring(3) :
                        item.mobilePhone.replace(/\+/g,' ').trim() :  item.PhoneNumber.startsWith("+1") ?  item.PhoneNumber.substring(2) : item.PhoneNumber.startsWith("1") ? item.PhoneNumber.substring(1) :
                        item.PhoneNumber.startsWith("+44") ?  item.PhoneNumber.substring(3) : item.PhoneNumber.startsWith("+61") ?  item.PhoneNumber.substring(3) : item.PhoneNumber.replace(/\+/g,' ').trim(); });
                        var isDuplicate = valueArr.some(function(item, idx){ 
                            return valueArr.indexOf(item) != idx 
                        });
                        
                        if(isDuplicate !== true){
                          this.props.setSelectedContacts(newSelectedContacts);
                        
                        }else{
                          newSelectedContacts.pop();
                        }
                        this.props.setSelectedContacts(newSelectedContacts);
                      }
                    }}
                    delimiters={delimiters}
                    placeholder={"Type a phone number"}
                  />
                </span>
                <div className="topEditBtn" >
                  <a
                    href="javascript:;void(0);"
                    className="more_icon crcl_icon"
                    id="show_info"
                    style={{
                      backgroundColor: "var(--primary)",
                      transition: "background 1s",
                    }}
                    onClick={() => {
                      commonMethod.hideLeftSection(); setTimeout(() => { this.props.setTabOpened("newmessage"); }, 100);
                      this.props.mobileMessageSection(true)
                    }}
                  >
                    <PlusIcon className="" fill={"var(--text)"} />
                  </a>
                </div>
              </div>
            </div>



            <div
              className="top_right d-flex"
              style={{ flex: 1, textAlign: "right", right: "10px", position: "absolute" }}
            >
              <a
                href="javascript:;void(0);"
                className="left_arrow"

              >
                <BackIcon id="newMessage-backArrow" className="blk_icon" onClick={() => {
                  commonMethod.hideLeftSection();
                  this.props.messageSelectedContactsCount(0);
                  this.props.mobileMessageSection(false);
                  setTimeout(() => {

                    document.getElementById('msg_tab')?.click();

                  }, 100);

                }} />
              </a>
              <a
                href="javascript:;void(0);"
                className="more_icon crcl_icon"
                id="show_info"
                style={{
                  backgroundColor: this.props.infoPanelOpened ? "var(--primary)" : "var(--onsurfacelow)",
                  transition: "background 1s",
                }}
                onClick={(event) => this.props.setInfoPanelOpened(!this.props.infoPanelOpened)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="27"
                  height="7"
                  viewBox="0 0 27 7"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          fill={this.props.infoPanelOpened ? "#fff" : "#000"}
                          d="M23.218.363a3.28 3.28 0 1 1 0 6.559 3.28 3.28 0 0 1 0-6.56z"
                        />
                      </g>
                      <g>
                        <path
                          fill={this.props.infoPanelOpened ? "#fff" : "#000"}
                          d="M13.38.363a3.28 3.28 0 1 1 0 6.559 3.28 3.28 0 0 1 0-6.56z"
                        />
                      </g>
                      <g>
                        <path
                          fill={this.props.infoPanelOpened ? "#fff" : "#000"}
                          d="M3.54.363a3.28 3.28 0 1 1 0 6.559 3.28 3.28 0 0 1 0-6.56z"
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          </div>
          <div className="chat_or_info">
            <div className="chat_sec">
              <div className="chat_bx chat_bx_New">
                <div className="chat_bxInner"></div>
                <div
                  className={this.state.displayEmojiPicker ? "msg_txtbx msg_txtbxDiv new-msg-txtbx-msg" : "msg_txtbx msg_txtbxDiv"}
                >
                  <div className="icons_msg_txtbx">
                    <a href="javascript:;void(0);" title="">
                      <GlobeIcon className="blk_icon" />
                    </a>
                    {
                      this.props.loggedInUserDefaultCountryCode === 1 || 61 ?
                        <label className="browse_file pic-icon-msgbox">
                          <a href="javascript:;void(0);" title="">
                            <PicIcon className="blk_icon" />
                          </a>
                          <input type="file" onChange={this.handleChange} id="inputImage" accept="image/*" />
                        </label>
                        :
                        null
                    }
                    {this.state.displayEmojiPicker ? (
                      <div id="emojiPicker" className="new-emoji-picker">
                        <Picker
                          onEmojiClick={(e, data) => { setTimeout(() => this.setState({ inputText: this.state.inputText + data.emoji, }), 1000); }}
                          preload={true}
                        ></Picker>
                      </div>
                    ) : null}
                    <a
                      href="javascript:;void(0);"
                      title=""
                      id="emojiPickerButton"
                      className={this.state.displayEmojiPicker ? "emoji-focus" : ""}
                    >
                      <EmojiIcon
                        onClick={() => { this.setState({ displayEmojiPicker: !this.state.displayEmojiPicker }); }}
                        className={this.state.displayEmojiPicker ? "primary_icon" : "blk_icon"}
                      />
                    </a>
                  </div>
                  <div className="srch_input srch_bx">

                  {this.state.file ?.length>0 && this.state.file !== null ?
                  this.state.file.map((img:any, idx:any) => (
                    <div className="chatImage" style={{ maxWidth: "50px",display:"inline-block",marginLeft:"20px" }}>
                      <img src={img.url || ''} onClick={ x=>setIndex(img.name,x)} style={{ height: "50px", width: "50px", borderRadius: '5px', border: '1px solid rgb(0 0 0 / 4%)' }} />
                      <progress id="progressBar" value={this.state.progressBar} style={{ width: "110%" }} max="100" ></progress>
                      <CrossIcon onClick={(e:any) =>{ this.setState({
                          file: [], fileName: ""
                        })
                       const imageElement=(document.getElementById('inputImage')as HTMLInputElement);
                       imageElement.value = "";
                      }
                        }></CrossIcon>
                    </div>
                  ))
                      :
                      null
                    }
                    {
                       
                        !!currentImage &&(
                           
                             /* @ts-ignore */
                             <Lightbox
                               mainSrc={currentImage.url}
                               imageTitle={currentImage.caption}
                               mainSrcThumbnail={currentImage.src}
                               nextSrc={nextImage.url}
                               nextSrcThumbnail={nextImage.url}
                               prevSrc={prevImage.url}
                               prevSrcThumbnail={prevImage.url}
                               onCloseRequest={handleClose}
                               onMovePrevRequest={handleMovePrev}
                               onMoveNextRequest={handleMoveNext}
                               discourageDownloads={false}
                               ></Lightbox>
                            
                      // this.state.isOpen && (
                      //   <Lightbox
                      //     mainSrc={this.state.file || ''}
                      //     onCloseRequest={() => this.setState({ isOpen: false })}
                      //   />
                      )}
                    <TextareaAutosize
                      rowsMin={1}
                      rowsMax={4}
                      style={{
                        resize: "none", backgroundColor: "var(--onsurfacelowest)",
                        fontFamily: "'roboto','Noto Color Emoji','Segoe UI Emoji', Times, Symbola, Aegyptus, Code1997, Code2001, Code2002, Musica, serif, LastResort",
                      }}
                      id="mainInput-SendMessage"
                      disabled={this.props.MFAUSER === true ? true : false}
                      value={this.state.inputText}
                      onChange={(e) => { this.setState({ inputText: e.target.value }); }}
                      className="form-control"
                      placeholder="Type a message..."
                      onKeyDown={this.sendMessage}
                    ></TextareaAutosize>
                  </div>
                  {this.props.MFAUSER === true ?  ""  : 
                   <a
                    href="javascript:;void(0);"
                    title=""
                    className={(this.state.inputText?.length === 0 && this.state.fileBlob === "") ? "gry_bg" : this.checkValidMessage ? "gry_bg" : "ylw_bg"}
                    onClick={() => {
                      if (this.state.inputText?.length > 0 || this.state.fileBlob !== "" && this.checkValidMessage !== true) {
                        if (this.state.disableSendMessage === false) {
                          this.sendMessage({ key: "Enter" });
                          this.setState({ inputText: "" });
                        }
                      }
                      const imageElement = (document.getElementById('inputImage') as HTMLInputElement);
                      if (imageElement !== null) {
                        imageElement.value = "";
                      }
                    }}
                  >
                  
                    <SendIcon
                      style={{ fill: this.checkValidMessage ? this.state.inputText?.length > 0 || this.state.fileBlob !== "" ? "var(--onsurfacehigh)" : "var(--onsurfacehigh)" : "var(--onsurfacehigh)", }}
                      className={this.state.inputText?.length > 0 || this.state.fileBlob !== "" ? "wht_icon" : "grey_icon"}
                    />
                  </a>
 }
                 
                </div>
              </div>
            </div>
            <Drawer
              className={this.props.infoPanelOpened ? "Drawer" : "Drawer Drawer-Open"}
              classes={{ paper: "MuiDrawer-paper2" }}
              variant="persistent"
              anchor="right"
              open={this.props.infoPanelOpened}
            >
              <div className="info_sec" style={{ left: "0px" }}>
                <div className="send_form">
                  <h5 className="grey_hedln"> Send from </h5>
                  <ul className="usr_list ">
                    <li className="slctd_dv" style={{ cursor: "pointer" }}>
                      <div className="usr_imgbx">
                        <div className="usr_img2">
                          {(this.state.sharedinboxname !== "" &&
                            this.state.sharedinboxname === store.getState().reduxReducer.loggedInUser.UserName) ||
                            this.state.SharedInbox.currentSelected.email === "" ? (
                            <UserIcon style={{ fill: "var(--onPrimary)" }} />
                          ) : (
                            <GroupLogo style={{ fill: "var(--surface)" }} />
                          )}
                        </div>
                      </div>
                      <div className="usr_txt">
                        <h3>
                          {" "}
                          {this.state.sharedinboxname !== "" ? this.state.sharedinboxname : this.state.SharedInbox ? this.state.SharedInbox.currentSelected.name : ""}
                        </h3>
                        <div className="txt_div">
                          <span className="sub_txt">
                            {this.state.sharedinboxuniquenumber !== "" ? this.state.sharedinboxuniquenumber : this.state.SharedInbox ? this.state.SharedInbox.currentSelected.UniqueNumber : ""}
                          </span>
                        </div>
                      </div>
                    </li>

                    {this.state.SharedInbox?.other?.length > 0 ? (
                      this.state.SharedInbox.other.filter((y: any) => y.name === store.getState().reduxReducer.loggedInUser.UserName).map((x: any, i: number) => {
                        return (
                          <li
                            key={i}
                            onClick={() => { this.setShareInbox(x); }}
                            style={{ cursor: "pointer" }}
                          >
                            <div className="usr_imgbx">
                              <div className="usr_img2 blk_bg">
                                {" "}
                                {x.email === "" ? (
                                  <UserIcon
                                    style={{ fill: "var(--onPrimary)" }}
                                  />
                                ) : (
                                  <GroupLogo
                                    style={{ fill: "var(--surface)" }} />
                                )}
                              </div>
                            </div>
                            <div className="usr_txt">
                              <h3> {x.name} </h3>
                              <div className="txt_div">
                                <span className="sub_txt">
                                  {" "}
                                  {x.UniqueNumber}
                                </span>
                              </div>
                            </div>
                          </li>
                        );
                      })
                    ) : (
                      <li></li>
                    )}
                    {this.state.SharedInbox?.other?.length > 0 ? (
                      this.state.SharedInbox.other
                        .filter((y: any) => y.name !== store.getState().reduxReducer.loggedInUser.UserName).map((x: any, i: number) => {
                          if (x.email === "Closed") return null;
                          return (
                            <li
                              key={i}
                              onClick={() => { this.setShareInbox(x); }}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="usr_imgbx">
                                <div className="usr_img2 blk_bg">
                                  {" "}
                                  {x.email === "" ? (
                                    <UserIcon
                                      style={{ fill: "var(--onPrimary)" }}
                                    />
                                  ) : (
                                    <GroupLogo
                                      style={{ fill: "var(--surface)" }}
                                    />
                                  )}
                                </div>
                              </div>
                              <div className="usr_txt">
                                <h3> {x.name} </h3>
                                <div className="txt_div">
                                  <span className="sub_txt">
                                    {" "}
                                    {x.UniqueNumber}
                                  </span>
                                </div>
                              </div>
                            </li>
                          );
                        })
                    ) : (
                      <li></li>
                    )}
                  </ul>
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (props: any) => {
  return {
    selectedContactsNewMessage: props.reduxReducer.selectedContactsNewMessage || [],
    infoPanelOpened: props.reduxReducer.infoPanelOpened,
    sharedInboxData: props.reduxReducer.sharedInboxData,
    loggedInUserDefaultCountryCode: props.reduxReducer.loggedInUser.DefaultCountryCode,
    loggedInUserDetail: props.reduxReducer.loggedInUser,
    newCount: props.reduxReducer.newCount,
    spinnerValue: props.reduxReducer.spinnerValue,
    ServicePlanId: props.reduxReducer.ServicePlanId,
    MFAUSER:props.reduxReducer.MFAUSER,

  };
};
const mapDispatchToProps = (dispatch: ThunkDispatch<{}, null, any>, props: any) => {
  return {
    setAlertData: (data: any) => {
      dispatch<any>(action.setAlertData(data));
    },
    setSelectedContacts: (contact: any) => {
      dispatch<any>(action.setSelectedContacts(contact));
    },
    setInfoPanelOpened: (open: boolean) => {
      dispatch<any>({ type: "setInfoPanelOpened", payload: open });
    },
    setTabOpened: (tab: string) => {
      dispatch<any>(action.setTabOpened(tab));
    },
    sendMessageProp: async (senderDetail: any, text: any, email: any, file: any) => {
      dispatch<any>(action.setSpinner(true))
      dispatch<any>(action.mobileMessageSection(false))
      let companyVersion=store.getState().reduxReducer.companyVersion;
      if(companyVersion===2)
      {
      dispatch<any>(action.SendMessage_V2(senderDetail, text, email, file));
      dispatch<any>(action.sendNewMsgMailChimp_Zoho_V2(store.getState().reduxReducer.loggedInUser.user.Email));
      }
      else
      {
        dispatch<any>(action.SendMessage(senderDetail, text, email, file));
        dispatch<any>(action.sendNewMsgMailChimp_Zoho(store.getState().reduxReducer.loggedInUser.Email));
      }
      dispatch<any>(action.messageSelectedContactsCount(false))
      
      //dispatch<any>( action.sendNewMsgZoho(store.getState().reduxReducer.loggedInUser.Email));
    },
    setCurrentSelectedSharedEmail: (email: string) => {
      dispatch<any>(action.setCurrentSelectedSharedEmail(email, "InfoPanel", ""));
    },
    messageSelectedContactsCount: (value: any) => {
      dispatch<any>(action.messageSelectedContactsCount(value))
    },
    mobileMessageSection: (data: any) => {
      dispatch<any>(action.mobileMessageSection(data))
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NewMessage);
